export function isEmpty(str) {
    return (str?.length === 0 || !str?.trim());
}
